/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { ICourse, TUpdateCourse } from '../CoursesSlice';
import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ISection, TUpdateCourseSectionAsUser } from '../SectionSlice';

export type TUpdateCourseSectionSortingAsUser = {
  sections: Array<{ _id: string; sortingKey: number }>;
  course: string;
};

const apiDataProvider = new APIDataProvider();

export const updateCourseAsUserSavingSlice = createAsyncThunk(
  '/saving/courses/updateOne',
  async ({ _id, ...data }: TUpdateCourse) => {
    const path = `${ApiPaths.courses}/${_id}`;
    const response = await apiDataProvider.put<TApiResponse<ICourse>>(
      path,
      data
    );

    return response.data;
  }
);

export const updateCourseSectionAsUserSavingSlice = createAsyncThunk(
  '/saving/sections/update',
  async ({ _id, ...data }: TUpdateCourseSectionAsUser) => {
    const path = `${ApiPaths.sections}/${_id}`;
    const response = await apiDataProvider.put<TApiResponse<ISection>>(
      path,
      data
    );

    return response.data;
  }
);

export const updateCourseSectionsSortingAsUserSavingSlice = createAsyncThunk(
  '/saving/sections/update-sorting-keys',
  async (data: TUpdateCourseSectionSortingAsUser) => {
    const path = `${ApiPaths.sections}/update-sorting-keys`;
    const response = await apiDataProvider.put<TApiResponse<ISection[]>>(
      path,
      data
    );

    return response.data;
  }
);
